import { AboutController } from './about.controller';

export const initialise = () => {

  const aboutModule = angular.module('app.about', [, 'actora.services']);

  aboutModule.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('about', {
      url: '/about',
      templateUrl: 'app/angularJS/features/about/about.html',
      controller: 'aboutController',
      controllerAs: 'vm',
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }]);

  aboutModule.controller('aboutController', <any>AboutController);
};